module.exports = __webpack_public_path__ + "static/media/statistics.138e9ebf.svg";